<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7083 7.5H7.29167M12.7083 10.8333H7.29167M7.74518 15.403L9.46608 16.8456C9.77433 17.104 10.2232 17.1052 10.5331 16.8486L12.2817 15.3999C12.4311 15.2761 12.6192 15.2083 12.8132 15.2083H15.2083C16.1288 15.2083 16.875 14.4622 16.875 13.5417V4.79167C16.875 3.87119 16.1288 3.125 15.2083 3.125H4.79167C3.87119 3.125 3.125 3.87119 3.125 4.79167V13.5417C3.125 14.4622 3.87119 15.2083 4.79167 15.2083H7.20985C7.40563 15.2083 7.59515 15.2773 7.74518 15.403Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CommentsIcon'
}
</script>

